import { useEffect, useState } from "react";
import SimpleCombobox from "../../components/SimpleCombobox";
import api from "../../api";
import { TrashIcon } from "@heroicons/react/20/solid";

export const DatosGenerales = ({
    surgeryData,
    handleChange,
    setSurgeryData,
    surgerySchedules,
    formErrors,
}) => {
    return (
        <div className="bg-white min-h-[570px] py-8 px-6 lg:px-8 rounded-md shadow-md ">
            <div className="lg:w-9/12 flex-col space-y-6">
                <div className="flex flex-col lg:flex-row gap-6">
                    <div className="flex flex-col w-7/12">
                        <label
                            htmlFor="patient"
                            className="block font-semibold leading-6 text-gray-900"
                        >
                            Nombre y apellido
                        </label>
                        <input
                            type="text"
                            name="patient"
                            id="patient"
                            className="input-style disabled:bg-gray-100 cursor-not-allowed"
                            value={surgerySchedules.patient?.fullName}
                            disabled
                        />
                    </div>
                    <div className="flex flex-col gap-3">
                        <label className="block font-semibold leading-6 text-gray-900">
                            ¿La ciruía fue suspendida?
                        </label>
                        <div className="flex flex-row gap-10">
                            <div className="flex flex-row gap-3 items-center">
                                <input
                                    type="radio"
                                    id="si"
                                    name="wasCanceled"
                                    value="si"
                                    checked={surgeryData.wasCanceled === true}
                                    onChange={() =>
                                        setSurgeryData((prev) => ({
                                            ...prev,
                                            wasCanceled: true,
                                        }))
                                    }
                                />
                                <label htmlFor="si">Si</label>
                            </div>
                            <div className="flex flex-row gap-3 items-center">
                                <input
                                    type="radio"
                                    id="no"
                                    name="wasCanceled"
                                    value="no"
                                    checked={surgeryData.wasCanceled === false}
                                    onChange={() =>
                                        setSurgeryData((prev) => ({
                                            ...prev,
                                            wasCanceled: false,
                                        }))
                                    }
                                />
                                <label htmlFor="no">No</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col">
                    <label
                        htmlFor="cancellationReason"
                        className="block font-semibold leading-6 text-gray-900"
                    >
                        Motivo de suspensión
                    </label>
                    <input
                        type="text"
                        name="cancellationReason"
                        id="cancellationReason"
                        className="input-style"
                        value={surgeryData.cancellationReason}
                        onChange={(e) =>
                            handleChange("cancellationReason", e.target.value)
                        }
                    />
                </div>
                <div className="flex flex-col lg:flex-row gap-6 lg:gap-64">
                    <div className="flex flex-col gap-3">
                        <label className="block font-semibold leading-6 text-gray-900">
                            ¿Es un paciente privado?
                        </label>
                        <div className="flex flex-row gap-10">
                            <div className="flex flex-row gap-3 items-center">
                                <input
                                    type="radio"
                                    id="si"
                                    name="isPrivatePatient"
                                    value="si"
                                    checked={
                                        surgeryData.isPrivatePatient === true
                                    }
                                    onChange={() =>
                                        setSurgeryData((prev) => ({
                                            ...prev,
                                            isPrivatePatient: true,
                                        }))
                                    }
                                />
                                <label htmlFor="si">Si</label>
                            </div>

                            <div className="flex flex-row gap-3 items-center">
                                <input
                                    type="radio"
                                    id="no"
                                    name="isPrivatePatient"
                                    value="no"
                                    checked={
                                        surgeryData.isPrivatePatient === false
                                    }
                                    onChange={() =>
                                        setSurgeryData((prev) => ({
                                            ...prev,
                                            isPrivatePatient: false,
                                        }))
                                    }
                                />
                                <label htmlFor="no">No</label>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col gap-3">
                        <label className="block font-semibold leading-6 text-gray-900">
                            Quirofano
                        </label>
                        <div className="flex flex-row gap-10">
                            <div className="flex flex-row gap-3 items-center">
                                <input
                                    type="radio"
                                    id="quirofano_1"
                                    name="operatingRoom"
                                    value={1}
                                    checked={surgeryData.operatingRoom === 1}
                                    onChange={() =>
                                        setSurgeryData((prev) => ({
                                            ...prev,
                                            operatingRoom: 1,
                                        }))
                                    }
                                />
                                <label htmlFor="quirofano_1">1</label>
                            </div>

                            <div className="flex flex-row gap-3 items-center">
                                <input
                                    type="radio"
                                    id="quirofano_2"
                                    name="operatingRoom"
                                    value={2}
                                    checked={surgeryData.operatingRoom === 2}
                                    onChange={() =>
                                        setSurgeryData((prev) => ({
                                            ...prev,
                                            operatingRoom: 2,
                                        }))
                                    }
                                />
                                <label htmlFor="quirofano_2">2</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-6">
                    <div className="flex flex-col">
                        <label
                            htmlFor="surgeryDate"
                            className="block font-semibold leading-6 text-gray-900"
                        >
                            Fecha de la cirugía
                        </label>
                        <input
                            type="date"
                            name="surgeryDate"
                            id="surgeryDate"
                            value={surgeryData.surgeryDate}
                            onChange={(e) =>
                                handleChange("surgeryDate", e.target.value)
                            }
                            className={`input-style min-w-[195px] ${
                                formErrors.surgeryDate.message && "input-error"
                            }`}
                        />
                        {formErrors.surgeryDate.message && (
                            <p className="mt-2 text-sm text-red-600">
                                {formErrors.surgeryDate.message}
                            </p>
                        )}
                    </div>
                    <div className="flex flex-col">
                        <label
                            htmlFor="startTime"
                            className="block font-semibold leading-6 text-gray-900"
                        >
                            Hora de inicio de la cirugía
                        </label>
                        <input
                            type="time"
                            name="startTime"
                            id="startTime"
                            className={`input-style min-w-[195px] ${
                                formErrors.startTime.message && "input-error"
                            }`}
                            value={surgeryData.startTime}
                            onChange={(e) =>
                                handleChange("startTime", e.target.value)
                            }
                        />
                        {formErrors.startTime.message && (
                            <p className="mt-2 text-sm text-red-600">
                                {formErrors.startTime.message}
                            </p>
                        )}
                    </div>
                    <div className="flex flex-col">
                        <label
                            htmlFor="endTime"
                            className="block font-semibold leading-6 text-gray-900"
                        >
                            Hora de finalización
                        </label>
                        <input
                            type="time"
                            name="endTime"
                            id="endTime"
                            className={`input-style min-w-[195px] ${
                                formErrors.endTime.message && "input-error"
                            }`}
                            value={surgeryData.endTime}
                            onChange={(e) =>
                                handleChange("endTime", e.target.value)
                            }
                        />
                        {formErrors.endTime.message && (
                            <p className="mt-2 text-sm text-red-600">
                                {formErrors.endTime.message}
                            </p>
                        )}
                    </div>
                </div>
                <div className="flex flex-col">
                    <label
                        htmlFor="preoperativeDiagnosis"
                        className="block font-semibold leading-6 text-gray-900"
                    >
                        Diagnostico pre operatorio
                    </label>
                    <textarea
                        name="preoperativeDiagnosis"
                        rows={4}
                        className={`input-style ${
                            formErrors.preoperativeDiagnosis.message &&
                            "input-error"
                        }`}
                        value={surgeryData.preoperativeDiagnosis}
                        onChange={(e) =>
                            handleChange(
                                "preoperativeDiagnosis",
                                e.target.value
                            )
                        }
                    ></textarea>
                    {formErrors.preoperativeDiagnosis.message && (
                        <p className="mt-2 text-sm text-red-600">
                            {formErrors.preoperativeDiagnosis.message}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export const Enfermeria = ({
    surgeryData,
    setSurgeryData,
    nurse,
    formErrors,
}) => {
    const handleChange = (field, value) => {
        setSurgeryData((prev) => ({
            ...prev,
            [field]: value?.id,
        }));
    };
    return (
        <div className="bg-white min-h-[570px] py-8 px-6 lg:px-8 rounded-md shadow-md ">
            <div className="lg:w-9/12 flex-col space-y-6">
                <div className="flex flex-col">
                    <SimpleCombobox
                        inputClassName="relative mt-1"
                        placeholder={"Seleccionar enfermera"}
                        value={
                            nurse.find((m) => m.id === surgeryData.nurse) ||
                            null
                        }
                        handleChange={handleChange}
                        name="nurse"
                        label="Enfermera responsable"
                        className="shadow-sm pl-2 mt-1 w-full bg-white border border-gray-300 focus:ring-primary focus:border-primary block sm:text-sm rounded-md"
                        options={nurse}
                    />
                    {formErrors.nurse.message && (
                        <p className="mt-2 text-sm text-red-600">
                            {formErrors.nurse.message}
                        </p>
                    )}
                </div>
                <div className="flex flex-col">
                    <label
                        htmlFor="preoperativeDiagnosisNursing"
                        className="block font-semibold leading-6 text-gray-900"
                    >
                        Diagnostico pre operatorio
                    </label>
                    <textarea
                        name="preoperativeDiagnosisNursing"
                        rows={4}
                        className={`input-style ${
                            formErrors.preoperativeDiagnosisNursing.message &&
                            "input-error"
                        }`}
                        value={surgeryData.preoperativeDiagnosisNursing}
                        onChange={(e) =>
                            setSurgeryData((prev) => ({
                                ...prev,
                                preoperativeDiagnosisNursing: e.target.value,
                            }))
                        }
                    ></textarea>
                    {formErrors.preoperativeDiagnosisNursing.message && (
                        <p className="mt-2 text-sm text-red-600">
                            {formErrors.preoperativeDiagnosisNursing.message}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export const TecnicaQuirurgica = ({
    surgeryData,
    handleChange,
    formErrors,
    setSurgeryData,
}) => {
    const techniques = [
        // CIRUGIA DE PTERIGION CON AUTOINJERTO
        `Campo con IOP solución
Colocación de compresas estériles
Colocación de Steri-Strip y blefaróstato
Disección del pterigion de cabeza-cuerpo
Sección del pterigion
Fresado de la cornea
Se saca autoinjerto de conjuntiva superior
Se sutura el autoinjerto de lado nasal
Se sutura conjuntiva superior
Oclusión con ATB +corticoide`,

        // CIRUGIA DE PTERIGION SIN AUTOINJERTO
        `Campo con IOP solución
Colocación de compresas estériles
Colocación de Steri-Strip y blefaróstato
Disección del pterigion de cabeza-cuerpo
Sección del pterigion
Fresado de la cornea
Se sutura la conjuntiva por primera intención
Oclusión con ATB +corticoide`,

        // CIRUGIA EECC + LIO EN SACO CAPSULAR
        `Campo con IOP solución
Colocación de compresas estériles
Colocación de Steri-Strip y blefaróstato
Peritomia limbar superior base-fornix
Cauterización de vasos esclerales
Surco escleral con bisturí nro. 15
Esclerotomía con bisturí nro. 11 a hora 12
Formación de CA con sustancia viscoelástica
Capsulotomía anterior
Luxación a CA de núcleo cristaliniano
Ampliación de esclerotomía a 10mm
Extracción de núcleo con ansa
Irrigación de CA y aspiración de restos cristalinianos
Formación de saco capsular con sustancia viscoelástica
Colocación de LIO en CP
Irrigación de CA y aspiración de sustancia viscoelástica
Cierre de esclerotomía con Nylon 10/0
Cierre de peritomía con electro fulguración`,

        // CX CATARATA CON FACOEMULSIFICACIÓN
        `Campo con IOP solución
Colocación de compresas estériles
Colocación de Steri-Stripe y blefaróstato
Peritomia limbar superior base-fornix
Cauterización de vasos esclerales
Surco escleral con cuchilletes .15 y cresent
Esclerotomía con cuchilletes 2.75
Formación de CA con sustancia viscoelástica
Capsulorrexis
Hidrodisección
Facoemulsificación del nucleo
Irrigación de CA y aspiración de restos cristalinianos
Formación de saco capsular con sustancia viscoelástica
Colocación de LIO en CP
Irrigación de CA y aspiración de sustancia viscoelástica
Cierre de esclerotomía con Nylon 10/0
Cierre de peritomía con electrofulguración`,

        // CIRUGIA DE TRABECULECTOMIA
        `Campo con IOP solución
Colocación de compresas estériles
Colocación de Steri-Strip y blefaróstato
Peritomia limbar superior base-fornix
Cauterización de vasos esclerales
Flap escleral con cuchilletes
Colocación de 5FU por 2 minutos sobre esclera
Esclerotomía profunda con cuchilletes
Iridectomía 
Formación de CA con sustancia viscoelástica
Sutura escleral puntos separados
Se sutura conjuntiva superior
Oclusión con ATB +corticoide`,

        // CIRUGIA DE EECC + TRABECULECTOMIA
        `Campo con IOP solución
Colocación de compresas estériles
Colocación de Steri-Strip y blefaróstato
Peritomia limbar superior base-fornix
Cauterización de vasos esclerales
Flap escleral con cuchilletes
Colocación de 5FU por 2 minutos sobre esclera
Surco escleral con bisturí nro. 15 a los lados del flap
Esclerotomía con bisturí nro. 11 a hora 12
Formación de CA con sustancia viscoelástica
Capsulotomía anterior
Luxación a CA de núcleo cristaliniano
Ampliación de esclerotomía a los lados del flap
Extracción de núcleo con ansa
Irrigación de CA y aspiración de restos cristalinianos
Formación de saco capsular con sustancia viscoelástica
Colocación de LIO en CP
Irrigación de CA y aspiración de sustancia viscoelástica
Esclerotomía profunda con cuchilletes
Iridectomía 
Formación de CA con sustancia viscoelástica
Sutura escleral puntos separados
Se sutura conjuntiva superior
Oclusión con ATB +corticoide`,
    ];
    const handleSelect = (e) => {
        const index = e.target.value;
        const technique = techniques[index] || "";
        setSurgeryData((prev) => ({
            ...prev,
            surgicalTechnique: technique,
        }));
    };
    return (
        <div className="bg-white min-h-[570px] py-8 px-6 lg:px-8 rounded-md shadow-md ">
            <div className="lg:w-11/12 flex flex-col lg:flex-row gap-10">
                <div className="">
                    <label
                        htmlFor="surgicalTechnique"
                        className="block font-semibold leading-6 text-gray-900"
                    >
                        Seleccionar Técnica
                    </label>
                    <select
                        name="selectTechnique"
                        id="selectTechnique"
                        className={`input-style`}
                        onChange={handleSelect}
                        defaultValue=""
                    >
                        <option value="" disabled hidden>
                            -- Seleccione una técnica quirúrgica --
                        </option>
                        <option value={0}>
                            CIRUGIA DE PTERIGION CON AUTOINJERTO
                        </option>
                        <option value={1}>
                            CIRUGIA DE PTERIGION SIN AUTOINJERTO
                        </option>
                        <option value={2}>
                            CIRUGIA EECC +LIO EN SACO CAPSULAR
                        </option>
                        <option value={3}>
                            CX CATARATA CON FACOEMULSIFICACIÓN
                        </option>
                        <option value={4}>CIRUGIA DE TRABECULECTOMIA</option>
                        <option value={5}>
                            CIRUGIA DE EECC + TRABECULECTOMIA
                        </option>
                    </select>
                </div>
                <div className="flex-1 flex flex-col">
                    <label
                        htmlFor="surgicalTechnique"
                        className="block font-semibold leading-6 text-gray-900"
                    >
                        Técnica Quirúrgica
                    </label>
                    <textarea
                        name="surgicalTechnique"
                        rows={15}
                        className={`input-style ${
                            formErrors.surgicalTechnique.message &&
                            "input-error"
                        }`}
                        value={surgeryData.surgicalTechnique}
                        onChange={(e) =>
                            handleChange("surgicalTechnique", e.target.value)
                        }
                    ></textarea>
                    {formErrors.surgicalTechnique.message && (
                        <p className="mt-2 text-sm text-red-600">
                            {formErrors.surgicalTechnique.message}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export const FichaAnestesica = ({ surgeryData, handleChange, formErrors }) => {
    return (
        <div className="bg-white min-h-[570px] py-8 px-6 lg:px-8 rounded-md shadow-md ">
            <div className="lg:w-9/12 flex-col space-y-6">
                <div className="flex flex-col w-full lg:w-6/12">
                    <label
                        htmlFor="anesthesiaType"
                        className="block font-semibold leading-6 text-gray-900"
                    >
                        Tipo de anestecia
                    </label>
                    <select
                        name="anesthesiaType"
                        id="anesthesiaType"
                        className={`input-style ${
                            formErrors.anesthesiaType.message && "input-error"
                        }`}
                        value={surgeryData.anesthesiaType}
                        onChange={(e) =>
                            handleChange("anesthesiaType", e.target.value)
                        }
                    >
                        <option value="" disabled hidden>
                            Seleccione una opción
                        </option>
                        <option value="1" selected>
                            Local
                        </option>
                        <option value="2" selected>
                            General
                        </option>
                        <option value="3" selected>
                            Sedación
                        </option>
                        <option value="4" selected>
                            Tópica
                        </option>
                    </select>
                    {formErrors.anesthesiaType.message && (
                        <p className="mt-2 text-sm text-red-600">
                            {formErrors.anesthesiaType.message}
                        </p>
                    )}
                </div>
                <div className="flex flex-col">
                    <label
                        htmlFor="patientResponses"
                        className="block font-semibold leading-6 text-gray-900"
                    >
                        Respuesta del paciente
                    </label>
                    <textarea
                        name="patientResponses"
                        rows={4}
                        className={`input-style ${
                            formErrors.patientResponses.message && "input-error"
                        }`}
                        value={surgeryData.patientResponses}
                        onChange={(e) =>
                            handleChange("patientResponses", e.target.value)
                        }
                    ></textarea>
                    {formErrors.patientResponses.message && (
                        <p className="mt-2 text-sm text-red-600">
                            {formErrors.patientResponses.message}
                        </p>
                    )}
                </div>
                <div className="flex flex-col">
                    <label
                        htmlFor="surgicalComplications"
                        className="block font-semibold leading-6 text-gray-900"
                    >
                        Complicaciones de la intervención
                    </label>
                    <textarea
                        name="surgicalComplications"
                        rows={4}
                        className={`input-style ${
                            formErrors.surgicalComplications.message &&
                            "input-error"
                        }`}
                        value={surgeryData.surgicalComplications}
                        onChange={(e) =>
                            handleChange(
                                "surgicalComplications",
                                e.target.value
                            )
                        }
                    ></textarea>
                    {formErrors.surgicalComplications.message && (
                        <p className="mt-2 text-sm text-red-600">
                            {formErrors.surgicalComplications.message}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export const Insumo = ({ surgeryData, handleChange, formErrors }) => {
    const [supplies, setSupplies] = useState([]);
    const [usedSupplies, setUsedSupplies] = useState(
        surgeryData.usedSupplies.length > 0 ? surgeryData.usedSupplies : []
    );
    useEffect(() => {
        api.supplies.getMulti().then((response) => {
            const supplyOptions = response.data.map((supply) => ({
                id: supply.id,
                name: supply.category,
            }));
            setSupplies(supplyOptions);
        });
    }, []);

    useEffect(() => {
        if (surgeryData.usedSupplies && surgeryData.usedSupplies.length > 0) {
            setUsedSupplies(surgeryData.usedSupplies);
        }
    }, [surgeryData]);

    const handleSupplyChange = (name, selectedOption, index) => {
        const newUsedSupplies = [...usedSupplies];
        if (selectedOption?.id) {
            newUsedSupplies[index].supply = selectedOption.id;
        }
        setUsedSupplies(newUsedSupplies);
        handleChange("usedSupplies", newUsedSupplies);
    };

    const handleQuantityChange = (index, quantity) => {
        const newUsedSupplies = [...usedSupplies];
        newUsedSupplies[index].quantity = Number(quantity);
        setUsedSupplies(newUsedSupplies);
        handleChange("usedSupplies", newUsedSupplies);
    };

    const handleRemove = (index) => {
        const newUsedSupplies = [...usedSupplies];
        newUsedSupplies.splice(index, 1);
        setUsedSupplies(newUsedSupplies);
        handleChange("usedSupplies", newUsedSupplies);
    };

    return (
        <div className="bg-white min-h-[570px] py-8 px-6 lg:px-8 rounded-md shadow-md ">
            <div className="lg:w-9/12 flex-col space-y-6">
                <h2 className="text-2xl font-semibold mb-6">
                    Insumos utilizados
                </h2>
                <div className="flex flex-col gap-8 lg:gap-6">
                    {usedSupplies?.map((item, index) => (
                        <div
                            key={`${item.supply}-${index}`}
                            className="flex flex-col lg:flex-row gap-2 lg:gap-10 items-start"
                        >
                            <div className="w-full lg:w-4/12">
                                <SimpleCombobox
                                    inputClassName="relative mt-1"
                                    placeholder={"Selecciona un insumo"}
                                    handleChange={handleSupplyChange}
                                    Idx={index}
                                    name="supply"
                                    label={`Insumo ${index + 1}`}
                                    className="shadow-sm pl-2 mt-1 w-full bg-white border border-gray-300 focus:ring-primary focus:border-primary block sm:text-sm rounded-md"
                                    options={supplies}
                                    value={
                                        supplies.find(
                                            (s) => s.id === item.supply
                                        ) ?? null
                                    }
                                />
                                {formErrors.usedSupplies.message && (
                                    <p className="mt-2 text-sm text-red-600">
                                        {
                                            formErrors.usedSupplies.message[
                                                index
                                            ]?.supply
                                        }
                                    </p>
                                )}
                            </div>
                            <div className="w-full lg:w-2/12">
                                <label className="block leading-6 text-gray-900">
                                    Cantidad
                                </label>
                                <input
                                    type="number"
                                    value={item.quantity}
                                    onChange={(e) =>
                                        handleQuantityChange(
                                            index,
                                            e.target.value
                                        )
                                    }
                                    className="input-style"
                                />
                            </div>
                            <button
                                type="button"
                                onClick={() => handleRemove(index)}
                            >
                                <TrashIcon className="mt-8 h-6 w-6 text-red-600" />
                            </button>
                        </div>
                    ))}
                </div>
                <button
                    type="button"
                    className="text-primary flex justify-center items-center rounded-md cursor-pointer hover:bg-gray-100 py-2 px-4"
                    onClick={() => {
                        setUsedSupplies([
                            ...usedSupplies,
                            { supply: null, quantity: 0 },
                        ]);
                    }}
                >
                    Agregar insumo
                </button>
            </div>
        </div>
    );
};
